import React, { useState, useEffect } from 'react';
import { useCartContents } from '@src/hooks';
import { QueryClient, QueryClientProvider, useQuery, useQueryClient } from 'react-query';
import CartButton from './CartButton';
import CartList from './CartList';
import { ReactDrawer } from '@parts';
const queryClient = new QueryClient();

const MiniCartProvider = (props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <MiniCart {...props}></MiniCart>
    </QueryClientProvider>
  );
};

const MiniCart = (props) => {
  const [open, setOpen] = useState(false);
  const { status, data: cartContents, error, isLoading } = useCartContents();
  const queryClient = useQueryClient();
  const ctx = window.theme_app;

  // Update cart and open when adding to cart
  useEffect(() => {
    ctx.on('cart.update', (state) => {
      queryClient.invalidateQueries('cart');
      if (window.location.pathname !== '/cart') {
        setOpen(true);
      }
    });
  }, []);

  useEffect(() => {
    if (cartContents) {
      ctx.hydrate({ systemCart: cartContents, cartContents: { items: cartContents.items, item_count: cartContents.item_count } });
    }
  }, [cartContents]);

  if (isLoading) {
    return null;
  }

  const { items, item_count, total_price } = cartContents;

  return (
    <>
      <CartButton handleClick={setOpen} open={open} itemCount={item_count}></CartButton>
      <ReactDrawer className="MiniCart" id="miniCartDrawer" showDrawer={open} setShowDrawer={setOpen} position={'right'}>
        <header className="Drawer__header">
          <h3>Your Cart</h3>
          <button
            type="button"
            className="Button Button--drawerClose"
            data-style="black text"
            data-layout="noLayout"
            onClick={() => setOpen(!open)}
            aria-label="Close"
          >
            <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
              <use href="#close"></use>
            </svg>
          </button>
        </header>
        <div className="Drawer__contents">

          <CartList data={cartContents} setShowDrawer={setOpen} />

        </div>
      </ReactDrawer>
    </>
  );
};

export default MiniCartProvider;
